import { createContext, useContext } from 'react';
import { IContentFulRaw } from '../model/contentful-model';

export interface IAppContextStore {
  rawContentFul?: IContentFulRaw;
}

export const AppContext = createContext<IAppContextStore>({
  rawContentFul: {} as IContentFulRaw,
});

export const useAppContext = () => useContext(AppContext);
